// BR 巴西逻辑

import vueI18n from '@/i18n/locale'
import caculateWidthBy10FontSize from '@/pages-v2/ShopDetail/components/DiagnosisCommon/utils/caculateFontSize.js'
import {
  getMaxValue,
  getMaxLengthValue,
  isSmallScreenMobile,
} from '@/pages-v2/ShopDetail/components/DiagnosisCommon/utils/utils.js'
import {
  LegendBuilder,
  XAxisBuilder,
  YAxisBuilder,
  WeekendBuilder,
  ToolTipBuilder,
  getEchartHeightAndBottomByLocale,
} from '../builderBR.js'

const investEchartConfig = getEchartHeightAndBottomByLocale('promotionInvest')
const promoEchartConfig = getEchartHeightAndBottomByLocale('promotionPromo')

export default function transformer(data = {}, dateToWeek = {}, key = 'promotion', direction) {
  const { name, period, indicators } = data

  const verticalHeight = isSmallScreenMobile()
    ? investEchartConfig.height // 小屏（竖屏）
    : investEchartConfig.height
  const horizontalHeight = isSmallScreenMobile()
    ? investEchartConfig.heightHor // 小屏（横屏）
    : investEchartConfig.heightHor
  const chartHeight = direction === 'vertical' ? verticalHeight : horizontalHeight

  const verticalPromoHeight = isSmallScreenMobile()
    ? promoEchartConfig.height // 小屏（竖屏）
    : promoEchartConfig.height
  const horizontalPromoHeight = isSmallScreenMobile()
    ? promoEchartConfig.heightHor // 小屏（横屏）
    : promoEchartConfig.heightHor
  const chartPromoHeight = direction === 'vertical' ? verticalPromoHeight : horizontalPromoHeight

  return {
    title: name,
    period,
    indicators,
    chartData: [
      parseInvestChartsData(data.chartData, dateToWeek, direction, chartHeight), // 投资
      parsePromoChartsData(data.chartData, dateToWeek, direction, chartPromoHeight), // 营销
    ],
    chartHeight,
    chartkey: key,
  }
}

function parseInvestChartsData(chartData = {}, dateToWeek, direction, chartHeight) {
  const {
    rBurnRatio = [], // BBurn
    bBurnRatio = [], // RBurn
  } = chartData || {}
  const maxRadio = getMaxLengthValue({ radio: rBurnRatio.concat(bBurnRatio) })
  const xAxisData = rBurnRatio.map(item => item.date)
  // rate 折线率类型的图表计算左右间距
  const baseWidth = maxRadio
    ? caculateWidthBy10FontSize(maxRadio + '%')
    : caculateWidthBy10FontSize(0, 5)
  const left = baseWidth + 10
  const right = baseWidth + 10
  return {
    grid: {
      top: 26,
      left,
      right,
      bottom: direction === 'vertical' ? investEchartConfig.bottom : investEchartConfig.bottomHor,
    },
    tooltip: ToolTipBuilder({
      position: { left: 0, bottom: chartHeight },
    }),
    legend: LegendBuilder([
      {
        name: vueI18n.t('FoodB_2_R_Burn_AyGL' /** R burn/ GMV */),
        icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
      },
      {
        name: vueI18n.t('FoodB_list_B_Burn_LIiU' /** B2C burn / GMV */),
        icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
      },
    ]),
    xAxis: XAxisBuilder({ data: xAxisData.map(item => item.substring(5)) }),
    yAxis: [
      YAxisBuilder({
        name: '',
        // 暂优化掉标题：
        // vueI18n.t('FoodB_2_R_Burn_AyGL' /** R burn/ GMV */) + '/' + vueI18n.t('FoodB_list_B_Burn_LIiU' /** B2C burn / GMV */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left + 8],
        },
        axisLabel: {
          formatter: '{value}%',
          fontSize: 10,
          color: '#8D9099',
        },
      }),
    ],
    series: [
      {
        name: vueI18n.t('FoodB_2_R_Burn_AyGL' /** R burn/ GMV */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 0,
        color: '#41CD16',
        lineStyle: {
          width: 1.5,
        },
        data: rBurnRatio.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodB_list_B_Burn_LIiU' /** B2C burn / GMV */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 0,
        color: '#FF9A34',
        lineStyle: {
          width: 1.5,
        },
        data: bBurnRatio.map(item => item.value ?? '--'),
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
  }
}

function parsePromoChartsData(chartData = {}, dateToWeek, direction, chartHeight) {
  const {
    completeOrderCntNotAct = [], // 非营销完单量
    completeOrderCntTwoPlusAct = [], // 两种营销类型及以上完单量
    completeOrderCntOneActSpecialCombo = [], // 营销 - 套餐
    completeOrderCntOneActSpecialNonCombo = [], // 特价餐(非套餐）
    completeOrderCntOneActFreedelivery = [], // 单营销类型[免配送]完单量
    completeOrderCntOneActBuygift = [], // 单营销类型[买赠]完单量
    completeOrderCntOneActReduction = [], // 单营销类型[满减]完单量
    completeOrderCntOneActStorecoupon = [], // 单营销类型[商家券]完单量
    rBurnRatio = [], // BBurn
    bBurnRatio = [], // RBurn
    cBurnRatio = [], // C Burn
  } = chartData || {}
  const max = getMaxValue(chartData, ['rBurnRatio', 'bBurnRatio', 'cBurnRatio'])
  const maxRadio = getMaxLengthValue({ radio: rBurnRatio.concat(bBurnRatio).concat(cBurnRatio) })

  const xAxisData = completeOrderCntNotAct.map(item => item.date)
  const left = (max ? caculateWidthBy10FontSize(max) + 8 : 16) + 8
  const right =
    (maxRadio ? caculateWidthBy10FontSize(maxRadio + '%') : caculateWidthBy10FontSize(0, 5)) + 8
  return {
    grid: {
      top: 26,
      left,
      right,
      bottom: direction === 'vertical' ? promoEchartConfig.bottom : promoEchartConfig.bottomHor,
    },
    tooltip: ToolTipBuilder({
      position: { left: 0, bottom: chartHeight },
    }),
    legend: LegendBuilder([
      vueI18n.t('FoodB_0919__etPs' /** 多种类营销 */),
      // 菜品
      vueI18n.t('Gattaran_opt_swMT_sNcV' /** 营销-套餐 */),
      vueI18n.t('Gattaran_opt_RltV_fDyM' /** 特价餐(非套餐） */),
      vueI18n.t('FoodB_optimization_Special_Meal_YtqD' /** 特价菜 */),
      vueI18n.t('FoodB_SMS__promotion_EKZy' /** 免配送 */),
      vueI18n.t('FoodB_optimization_Buy_gifts_daUI' /** 买赠 */),
      vueI18n.t('FoodB_optimization_Full_reduction_NlOa' /** 满减 */),
      vueI18n.t('FoodC_intostore_Store_Coupon_kHwh' /** 商家券 */),
      vueI18n.t('FoodB_0919__YKYU' /** 非营销 */),
    ]),
    xAxis: XAxisBuilder({ data: xAxisData.map(item => item.substring(5)) }),
    yAxis: [
      YAxisBuilder({
        name: vueI18n.t('FoodB_APP_kvLF_MMXl' /** 日完单量 */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left + 8],
        },
      }),
    ],
    series: [
      {
        name: vueI18n.t('FoodB_0919__etPs' /** 多种类营销 */),
        type: 'bar',
        barWidth: 4,
        color: '#D14F1F',
        stack: 'promotion',
        data: completeOrderCntTwoPlusAct.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('Gattaran_opt_swMT_sNcV' /** 营销-套餐 */),
        type: 'bar',
        barWidth: 4,
        color: '#FF8D5C',
        stack: 'promotion',
        data: completeOrderCntOneActSpecialCombo.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('Gattaran_opt_RltV_fDyM' /** 特价餐(非套餐） */),
        type: 'bar',
        barWidth: 4,
        color: '#ADDF6C',
        stack: 'promotion',
        data: completeOrderCntOneActSpecialNonCombo.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodB_SMS__promotion_EKZy' /** 免配送 */),
        type: 'bar',
        barWidth: 4,
        color: '#FFC9AD',
        stack: 'promotion',
        data: completeOrderCntOneActFreedelivery.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodB_optimization_Buy_gifts_daUI' /** 买赠 */),
        type: 'bar',
        barWidth: 4,
        color: '#F8AD21',
        stack: 'promotion',
        data: completeOrderCntOneActBuygift.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodB_optimization_Full_reduction_NlOa' /** 满减 */),
        type: 'bar',
        barWidth: 4,
        color: '#7FDFBF',
        stack: 'promotion',
        data: completeOrderCntOneActReduction.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodC_intostore_Store_Coupon_kHwh' /** 商家券 */),
        type: 'bar',
        barWidth: 4,
        color: '#09BA78',
        stack: 'promotion',
        data: completeOrderCntOneActStorecoupon.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodB_0919__YKYU' /** 非营销 */),
        type: 'bar',
        barWidth: 4,
        color: '#DADBE0',
        stack: 'promotion',
        data: completeOrderCntNotAct.map(item => item.value ?? '--'),
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
  }
}
